export default __webpack_public_path__ + "ee5cce5ff6a6d954700bad8cdec362d6.svg";